/**
 * @license
 * @copyright Copyright Motili Inc., 2017 All Rights Reserved
 */


module.exports = {
    path: '/m/quote/approval/:token',
    getComponent(nextState, callback) {
        require.ensure([], (require) => {
            callback(null, require('./QuoteApprovalContainer'));
        });
    }
};



// WEBPACK FOOTER //
// ./src/app/components/quote/quote-approval/route.QuoteApproval.js